import 'arrive';
import $ from 'jquery';
import Chart from 'chart.js';
import deferred from 'chartjs-plugin-deferred';

document.arrive('.block-chart', {existing: true}, function(){

  var $chartContainer = $(this);
  var $chartCanvas = $chartContainer.find('canvas');

  // Dataset
  var xaxis_data = JSON.parse('[' + $chartContainer.data('xaxis') + ']');
  var yaxis_data = JSON.parse('[' + $chartContainer.data('yaxis') + ']');

  var barChart = new Chart($chartCanvas.get(0).getContext("2d"), {
    type: 'bar',
    data: {
      labels: xaxis_data,
      datasets: [{
        data: yaxis_data,
        backgroundColor: 'rgba(90, 113, 144, 1)'
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          ticks: {
            fontColor: '#000',
          },
          gridLines: {
            color: 'transparent',
            drawBorder: false,
            display: false,
          }
        }],
        yAxes: [{
          ticks: {
            fontColor: '#000',
            padding: 6,
            beginAtZero: true
          },
          gridLines: {
            color: 'white',
            drawBorder: false
          }
        }]
      },
      plugins: {
        deferred: {           // enabled by default
            // xOffset: 150,     // defer until 150px of the canvas width are inside the viewport
            yOffset: '50%',   // defer until 50% of the canvas height are inside the viewport
            delay: 500        // delay of 500 ms after the canvas is considered inside the viewport
        }
    },
    }

  });

});